import axios from "axios";
import "dotenv";
import authHeader from "./AuthHeader";




const apiUrl = process.env.REACT_APP_URL;
const publicUrl = process.env.PUBLIC_URL;
const slug = "sr-latn/";// default lng
const api_lng = process.env.REACT_APP_LNG;
const getLogUserInfo = api_lng + "/api/auth/user";

class AuthService {


  generateEmailRequestUrl(url) {

    if (url == '/') {
      return '/#/'
    } else {
      return url + '/#/'
    }

  }


  getLng() {

    // prvo proverava u korisniku
    let user = this.getCurrentUser();
    if (user) {
      if (user.lng) {
        return user.lng
      }
    }

    // ako i to nema onda vraca iz env
    if (api_lng) {
      return api_lng;
    }

    // ako to nema onda radi auto detekciju
    let lng = localStorage.getItem("i18nextLng");
    if (lng) {
      return lng;
    }

    // vraca engleski na kraju kao podrazumevani
    return 'sr-latn'




  }



  login(username, password) {
    return axios
      .post(apiUrl + slug + "token/obtain/", {
        username,
        password,
      })
      .then((response) => {
        // console.log(response.data);
        if (response.data.access) {
          localStorage.setItem("token", JSON.stringify(response.data.access));
        }
        if (response.data.refresh) {
          localStorage.setItem("refresh", JSON.stringify(response.data.refresh));
        }

        if (true) {

          return axios
            .get(apiUrl + getLogUserInfo, {
              headers:
              {
                Authorization: "Bearer " + response.data.access,
                "Content-Type": "application/json",
                accept: "application/json",
              }
            })
            .then((res) => res.data).then((response) => {
              localStorage.setItem("user", JSON.stringify(response));
            });
        }


        return response.data;
      });
  }


  register(username, password, email) {

    const emailUrl = this.generateEmailRequestUrl(publicUrl);

    return axios.post(apiUrl + slug + "api/auth/register", {
      username,
      email,
      password,
      public_url: emailUrl
    }, {
      headers: authHeader(),

    }).then((response) => {
      // console.log(response.data);
      if (response.data.access) {
        localStorage.setItem("token", JSON.stringify(response.data.access));
      }
      if (response.data.refresh) {
        localStorage.setItem("refresh", JSON.stringify(response.data.refresh));
      }


      if (true) {

        axios
          .get(apiUrl + getLogUserInfo, {
            headers:
            {
              Authorization: "Bearer " + response.data.access,
              "Content-Type": "application/json",
              accept: "application/json",
            }
          })
          .then((res) => res.data).then((response) => {
            localStorage.setItem("user", JSON.stringify(response));
          });
      }


      return response.data;
    });
  }



  refresToken(username, password) {

    const token_old = JSON.parse(localStorage.getItem("token"));

    axios
      .post(apiUrl + slug + "token/refresh/", {
        token: token_old,
      })
      .then(
        (tokenRefreshResponse) => {

          localStorage.setItem(
            "refresh",
            '"' + tokenRefreshResponse.data.token + '"'
          );

        },
        // (reject) => {
        //   alert(i18n.t("session_expire"));
        //   AuthService.logout();
        //   window.location.reload();
        // }
      );
  }


  // da li je verifikovani user odnosno da li ne verifikovan email
  isVerified() {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      if (user.is_verified) {
        return true;
      }
      else return false;
    } else return false;
  }

  requestPasswordReset(email) {

    const emailUrl = this.generateEmailRequestUrl(publicUrl);

    return axios.post(apiUrl + slug + "api/auth/request-reset-email/", {
      email, public_url: emailUrl
    }, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  requestChangeEmail(email) {

    const emailUrl = this.generateEmailRequestUrl(publicUrl);

    return axios.patch(apiUrl + slug + "api/auth/change-email/", {
      email, public_url: emailUrl
    }, {
      headers: authHeader(),
    }).then((response) => {
      // preuzima info o useru sa servera i upi
      if (true) {

        axios
          .get(apiUrl + getLogUserInfo, {
            headers:
            {
              Authorization: "Bearer " + response.data.access,
              "Content-Type": "application/json",
              accept: "application/json",
            }
          })
          .then((res) => res.data).then((response) => {
            localStorage.setItem("user", JSON.stringify(response));
          });
      }
      return response.data;
    });
  }



  logout() {

    const refresh_token = JSON.parse(localStorage.getItem("token"));

    axios.post(apiUrl + slug + "blacklist/", {
      refresh: refresh_token,
    }, {
      headers: authHeader(),

    });

    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("refresh");
  }





  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  getToken() {
    return JSON.parse(localStorage.getItem("token"));
  }

  getTenant() {
    return 1;
  }

  isLoggedin() {
    // return true;
    let user = JSON.parse(localStorage.getItem("user"));

    if (user) {
      return true;
    } else return false;
  }



  getCurrentUserID() {
    let user = this.getCurrentUser();
    return user.id;
  }

  changeLanguage(lng) {
    let user = this.getCurrentUser();
    user.lng = lng;
    localStorage.setItem("user", JSON.stringify(user));
    return 1;
  }
}

export default new AuthService();
